import {
  IsCardBeforePaidCutoffHandler,
  useIsCardBeforePaidCutoff,
} from '@shared/data/billing/hooks/useIsCardBeforePaidCutoff';
import {
  CardsEntityService,
  CardsEntityServiceProps,
  useCardService,
} from '@shared/data/cards/CardsEntityService';
import { useReportCollectionViewScale } from '@shared/util/sentry';
import { OpenEntityHandler, useOpenEntityById } from './useOpenByEntityId';

export interface CollectionViewDataProps extends CardsEntityServiceProps {
  baseNavigationPath: string;
  dateComponentId?: string;
}

export interface CollectionViewData extends CardsEntityService {
  openEntity: OpenEntityHandler;
  getIsCardBeforePaidCutoff: IsCardBeforePaidCutoffHandler;
}

export function useCollectionViewData({
  workflowTemplateId,
  viewTemplateId,
  workspaceId,
  pageSize,
  baseNavigationPath,
  dateComponentId,
  treeParentComponentId,
  treeParentCardId,
}: CollectionViewDataProps): CollectionViewData {
  const cardService = useCardService({
    workflowTemplateId,
    viewTemplateId,
    pageSize,
    workspaceId,
    dateComponentId,
    treeParentComponentId,
    treeParentCardId,
  });
  const openEntity = useOpenEntityById(baseNavigationPath, workflowTemplateId);
  const getIsCardBeforePaidCutoff = useIsCardBeforePaidCutoff();

  // Scale context for long-task Sentry reports; each group's data source
  // registers separately and the registry sums them.
  useReportCollectionViewScale({
    loadedEntityCount: cardService.entities.length,
    totalEntityCount: cardService.totalCardCount,
  });

  return {
    ...cardService,
    openEntity,
    getIsCardBeforePaidCutoff,
  };
}
